<template>
  <div class="flex flex-col gap-4">
    <p class="text-xl font-semibold">
      Paso 1 de 3: Registra tus contactos en un solo paso
    </p>
    <ol class="list-decimal pl-6 flex flex-col gap-6 text-base font-normal">
      <li>
        <span class="font-medium">
          Descarga la plantilla.
        </span>
        <br>
        Usa el botón de abajo para descargar el archivo Excel con el formato correcto.
        <button
          type="button"
          class="text-tuin-100 hover:text-tuin_hover hover:underline"
          @click="downloadTemplate"
        >
          Descargar plantilla
        </button>.
      </li>

      <li>
        <span class="font-medium">
          Llena la plantilla.
        </span>
        <br>
        Abre el archivo y agrega la información de tus prospectos. Asegúrate de seguir el formato de cada columna para evitar errores.
      </li>

      <li>
        <span class="font-medium">
          Adjunta y carga el archivo.
        </span>
        <br>
        Sube el Excel completo aquí y presiona 
        <span class="font-medium">
          "Seleccionar archivo"
        </span>
        para registrar todos los contactos en un solo paso.
      </li>
    </ol>

    <InputFileComponent
      v-model="excel"
      :accept="'.xlsx,.xls'"
    />

    <div class="flex justify-end gap-2">
      <button
        class="px-5 py-2.5 text-sm font-medium border border-tuin-100 rounded-lg text-tuin-100 bg-white hover:bg-tuin_hover hover:text-white transition-colors"
        @click="$emit('close')"
      >
        Cancelar
      </button>
      <button
        class="px-5 py-2.5 text-sm font-medium bg-tuin-100 text-white rounded-lg hover:bg-tuin_hover transition-colors"
        @click="$emit('upload', excel)"
      >
        Continuar
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import InputFileComponent from "@/components/common/InputFileComponent.vue";

const store = useStore();
const session = computed(() => store.getters.getUserSession);
const excel = ref(null);

defineEmits(["close", "upload"]);

const downloadTemplate = async () => {
  try {
    const response = await fetch(
      `${process.env.VUE_APP_API_BASE_URL}/broker/lead/download-template`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${session.value.token_api}`,
        },
      }
    );

    if (response.status === 200) {
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "asesores_template.xlsx";

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    }
    
  } catch (error) {
    console.error(error);
  }
};
</script>
